var ROOT = "http://codingassets.discoveryeducation.co.uk/";

export default function makeAbsoluteUrl(url, undo) {
  //reverse operation
  if (undo) {
    return url.replace(ROOT, "");
  }

  //url is already absolute
  if (/^https?:\/\//.test(url)) {
    return url;
  }

  return ROOT + url.replace(/^\//, "");
}
